module.exports = __webpack_public_path__ + "img/W-S63.b35b2601.jpg";